// Links to the documentation site (Docusaurus, served on its own domain).
//
// The docs live on "docs.<app domain>" (e.g. chrometrica.ru -> docs.chrometrica.ru),
// so by default the URL is derived from the current host at runtime and the
// same frontend build works on every deployment. REACT_APP_DOCS_URL, if set at
// build time, overrides it. On localhost the production docs are used.
//
// Open docs with a plain <a href target="_blank">, not the router <Link>:
// they are a separate site.

const PRODUCTION_DOCS_URL = 'https://docs.chrometrica.ru';

const getDocsBaseUrl = () => {
  if (process.env.REACT_APP_DOCS_URL) {
    return process.env.REACT_APP_DOCS_URL.replace(/\/+$/, '');
  }
  const { protocol, hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return PRODUCTION_DOCS_URL;
  }
  return `${protocol}//docs.${hostname.replace(/^www\./, '')}`;
};

export const DOCS_URL = getDocsBaseUrl();

// docsLink('/chemometrics/methods/pls-da') -> full URL of a docs page
export const docsLink = (path = '/') =>
  `${DOCS_URL}${path.startsWith('/') ? path : `/${path}`}`;

// Docs page of every analysis type that has one (analysis_type -> path).
// 'linear' and 'pipeline' are not documented.
export const METHOD_DOCS = {
  pca: '/chemometrics/methods/pca',
  lda: '/chemometrics/methods/lda',
  logistic: '/chemometrics/methods/logistic',
  svm: '/chemometrics/methods/svm',
  random_forest: '/chemometrics/methods/random-forest',
  knn: '/chemometrics/methods/knn',
  plsda: '/chemometrics/methods/pls-da',
  simca: '/chemometrics/methods/simca',
  xgboost: '/chemometrics/methods/xgboost',
  bbc: '/chemometrics/methods/bbc',
  brf: '/chemometrics/methods/brf',
};

// Docs page of every visualization type (plot_type -> path).
export const PLOT_DOCS = {
  score_plot: '/chemometrics/visualizations/score-plot',
  loading_plot: '/chemometrics/visualizations/loading-plot',
  time_series: '/chemometrics/visualizations/time-series',
  heatmap: '/chemometrics/visualizations/heatmap',
  confusion_matrix: '/chemometrics/visualizations/confusion-matrix',
  roc_curve: '/chemometrics/visualizations/roc-curve',
  feature_importance: '/chemometrics/visualizations/feature-importance',
  knn_distance: '/chemometrics/visualizations/knn-distance',
  plsda_loading: '/chemometrics/visualizations/plsda-loading',
  permutation_plot: '/chemometrics/visualizations/permutation-plot',
  bootstrap_ci: '/chemometrics/visualizations/bootstrap-ci',
};
